import { formatDate } from "./helpers";

const billingCycleMonths = {
  monthly: 1,
  quarterly: 3,
  "half-yearly": 6,
  yearly: 12
};

const toMonthIndex = (monthValue) => {
  const match = String(monthValue || "").match(/^(\d{4})-(\d{2})/);
  if (!match) {
    return null;
  }

  return Number(match[1]) * 12 + Number(match[2]) - 1;
};

const coversMonth = (record, monthValue) => {
  const dueMonthIndex = toMonthIndex(record?.dueDate);
  const targetMonthIndex = toMonthIndex(monthValue);

  if (dueMonthIndex === null || targetMonthIndex === null) {
    return false;
  }

  const cycleMonths = billingCycleMonths[record?.billingCycle] || 1;
  return targetMonthIndex >= dueMonthIndex && targetMonthIndex < dueMonthIndex + cycleMonths;
};

export const getFeeCoverageForMonth = (records, monthValue) => {
  const coveredRecords = (records || []).filter((record) => coversMonth(record, monthValue));
  const paidRecord = coveredRecords.find((record) => record.status === "paid") || null;
  const currentRecord = paidRecord || coveredRecords[0] || null;

  return {
    currentRecord,
    isPaid: Boolean(paidRecord),
    helper: currentRecord
      ? `${currentRecord.status} ${currentRecord.billingCycle || "monthly"} fee from ${formatDate(currentRecord.dueDate)}`
      : `No fee record for ${monthValue}`
  };
};
